//防抖
export function debounce(fn, wait) {
    let timeout = null;
    wait = wait || 600;
    return function () {
      let that = this;
      if(timeout !== null)   clearTimeout(timeout);  
      timeout = setTimeout(() => {
        fn.apply(that);
      }, wait);
    }    
}

//替换指定传入参数的值,url为地址,paramName为参数,replaceWith为新值
export function replaceParamVal(url,paramName,replaceVal) {
    var oUrl = url.toString();
    var re=eval('/('+ paramName+'=)([^&]*)/gi');
    var nUrl = oUrl.replace(re,paramName+'='+replaceVal);
    return nUrl;
}

// 从URL中删除指定的查询参数 fields - 需要删除的字段名数组
export function removeUrlParams(url, fields) {
  // 处理参数为空或无效的情况
  if (!url || !fields || !fields.length) {
    return url;
  }

  try {
    // 创建URL对象以方便操作
    const urlObj = new URL(url, window.location.href);
    const params = new URLSearchParams(urlObj.search);

    // 删除指定的参数
    fields.forEach(field => {
      params.delete(field);
    });

    // 更新URL的查询字符串
    urlObj.search = params.toString();
    
    // 返回完整的URL（保留哈希部分）
    return urlObj.toString();
  } catch (error) {
    // 如果URL格式无效，返回原URL
    console.warn('Invalid URL:', url);
    return url;
  }
}

export function fileSuffix(fileName){
    let index = fileName.lastIndexOf(".");
    let extension = fileName.substring(index + 1, fileName.length);
    return extension.toLowerCase();
}

// 获取文件类型
export function generateFileIcon (fileSuffix) {
    if(['doc','docx','DOC','DOCX'].includes(fileSuffix)){
      return 'word'
    }else if(['xls','xlsx','XLS','XLSX'].includes(fileSuffix)){
      return 'excel'
    }else if(['PPT','PPTX','ppt','pptx'].includes(fileSuffix)){
      return 'ppt'
    }else if(['pdf','PDF','ofd','OFD'].includes(fileSuffix)){
      return 'pdf'
    }else if(['zip', '7z', 'tar', 'gz', 'bz2', 'ZIP',  '7Z', 'TAR', 'GZ', 'BZ2'].includes(fileSuffix)){
      return 'zip'
    }else if(['rar','RAR'].includes(fileSuffix)){
      return 'rar'
    }else if(['psd', 'PSD'].includes(fileSuffix)){
      return 'ps'
    }else if(['mp4', '3gp', 'ogg', 'webm', 'MP4', '3GP', 'OGG', 'WEBM','mov','MOV'].includes(fileSuffix)){
      return 'video'
    }else if(['MP3','WAV','AAC', 'mp3', 'wav', 'aac','m4a'].includes(fileSuffix)){
      return 'audio'
    }else if(['jpg', 'jpeg','JPG', 'JPEG'].includes(fileSuffix)){
      return 'jpg'
    }else if(['png','PNG'].includes(fileSuffix)){
      return 'png'
    }else if(['gif','GIF'].includes(fileSuffix)){
      return 'png'
    }else if(['gif', 'GIF'].includes(fileSuffix)){
      return 'picture'
    }else if(['AI', 'ai'].includes(fileSuffix)){
      return 'ai'
    }else {
        // 其他类型
        return 'other'
    }
}